import React from 'react';
import styled from 'styled-components';
import LogoImage from '../../Image/Cliniclogo.png'

const Footer = () => {
    return (
        <FooterMain>
            <FooterContainer>
                <Column>
                    <Logo src={LogoImage} alt="Logo" />
                    <NavLinks>
                        <NavLink href="#">567-B, Hakeema Wala Chowk, G.M Abad, Faisalabad.</NavLink>
                        <NavLink href="#">Call: +92 334-7860856</NavLink>
                        {/* <NavLink href="#">Pricing</NavLink>
                        <NavLink href="#">FAQs</NavLink> */}
                    </NavLinks>
                </Column>

                <Column>
                    <SectionHeading>Explore</SectionHeading>
                    <NavLinks>
                        <NavLink href="#">Feature</NavLink>
                        <NavLink href="#">About us</NavLink>
                        <NavLink href="#">FAQs</NavLink>
                        <NavLink href="#">Contact</NavLink>
                    </NavLinks>
                </Column>

                <Column>
                    <SectionHeading>Legal</SectionHeading>
                    <NavLinks>
                        <NavLink href="#">Privacy Policy</NavLink>
                        <NavLink href="#">Terms and Conditions</NavLink>
                        <NavLink href="#">Documentations</NavLink>
                        <NavLink href="#">Help Center</NavLink>
                    </NavLinks>
                </Column>

                <Column>
                    <SubscribeForm>
                        <SubscribeHeading>Subscribe</SubscribeHeading>
                        <SubscribeDescription>Subscribe to get the latest news from us .</SubscribeDescription>
                        {/* <div className=" w-50 gap-2"> */}
                        <SubscribeInput type="text" placeholder="Email address" />
                        <SubscribeButton>Subscribe</SubscribeButton>
                        {/* </div> */}
                    </SubscribeForm>
                </Column>
            </FooterContainer>
            <Hrline />
            <BottomFooter>
                <Copyright>&copy; 2023 Safia Medicare, All Rights Reserved</Copyright>
                <SocialLinks>
                    <SocialLink href="#"><SocialIcon className="bi" iconName="twitter" />
                        <svg
                            viewBox="0 0 1024 1024"
                            fill="currentColor"
                            height="2em"
                            width="2em"
                        >
                            <path d="M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0075-94 336.64 336.64 0 01-108.2 41.2A170.1 170.1 0 00672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 00-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 01-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 01-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" />
                        </svg>
                    </SocialLink>
                    <SocialLink href="#"><SocialIcon className="bi" iconName="instagram" />
                        <svg
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            height="2em"
                            width="2em"
                        >
                            <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0014.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z" />
                        </svg>
                    </SocialLink>
                    <SocialLink href="#"><SocialIcon className="bi" iconName="facebook" />
                        <svg
                            viewBox="0 0 1024 1024"
                            fill="currentColor"
                            height="2em"
                            width="2em"
                        >
                            <path d="M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" />
                        </svg>
                    </SocialLink>
                </SocialLinks>
            </BottomFooter>
        </FooterMain>
    );
};

export default Footer;

const FooterMain = styled.div`
  background-color: rgba(18, 204, 244, 0.05);
//   color: white;
// margin-top:20px;

`;
const Logo = styled.img`
  max-width: 100%; 
  height: auto;
  margin-bottom: 20px; 
`;
const FooterContainer = styled.div`
  width: 1180px;
  margin: 0 auto;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1200px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Column = styled.div`
  width: 100%;
  max-width: 200px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const SectionHeading = styled.h5`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 10px;
  font-family: Poppins;
font-size: 24px;
font-weight: 600;
line-height: 36px;
text-align: left;
color: rgba(6, 33, 38, 1);

`;

const NavLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
font-family: Poppins;
font-size: 18px;
font-weight: 500;
line-height: 27px;
text-align: left;
color: rgba(6, 33, 38, 0.6);


`;
const Hrline = styled.div`

border: 1px;
background: rgba(6, 33, 38, 0.1);
border: 1px solid rgba(6, 33, 38, 0.1);
`
const NavLink = styled.li`
  margin-bottom: 10px;
`;

const SubscribeForm = styled.form`
  max-width: 300px; 
 
`;

const SubscribeHeading = styled.h5`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

const SubscribeDescription = styled.p`
  margin-bottom: 20px;
`;

const SubscribeInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 45px;
  border: none; 
  padding: 5px;
  background-color: rgba(18, 204, 244, 0.1);
  margin-bottom: 10px; 

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const SubscribeButton = styled.button`
  width: 100%;
  height: 40px;
  background-color: rgba(36, 190, 224, 1);
  border-radius: 45px;
  gap: 10px;
  border: none;
  color: white;
  display: block; 
  cursor: pointer; 

  @media (max-width: 768px) {
    display: inline-block;
    width: auto;
  }
`;

const BottomFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
//   width:80%;
  margin-left:50px;
  margin-right:50px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Copyright = styled.p`
  font-size: 0.875rem;
  margin: 10px;
  color: rgba(6, 33, 38, 0.3);
  font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
text-align: left;
`;

const SocialLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
`;

const SocialLink = styled.li`
  margin-left: 10px;
`;

const SocialIcon = styled.i`
  width: 24px;
  height: 24px;
  color: black;

`;
